// ---
// Account view
// ---
class DashboardView {
  // Constructor
  constructor($el) {
    if (!$el.length) return

    const chartRoot = document.querySelector('.dashboard__chart-block')
    if (!chartRoot) return

    const statData = JSON.parse(chartRoot.dataset.stats)

    const parseDate = d3.timeParse('%Y-%m-%d')

    const signupsData = statData.weekly.map(entry => ({
      date: parseDate(entry.date),
      value: entry.signups,
    }))

    const revenueData = statData.weekly.map(entry => ({
      date: parseDate(entry.date),
      value: Math.round(entry.revenue / 100),
    }))

    const signupsRoot = chartRoot.querySelector('.dashboard__chart-graph--signups')
    const revenueRoot = chartRoot.querySelector('.dashboard__chart-graph--revenue')

    const signupsChart = new DashboardChart(signupsRoot, signupsData, {
      color: '#4277ce',
      type: 'signups',
      tooltipText: 'registered users',
      width: 490,
      height: 200,
    })

    const revenueChart = new DashboardChart(revenueRoot, revenueData, {
      color: '#fbd073',
      type: 'revenue',
      yAxisPrefix: '$',
      tooltipText: 'revenue',
      width: 490,
      height: 200,
    })

    signupsChart.render()
    revenueChart.render()

    // Filter
    const chartSelectRoot = document.querySelector('.dashboard__chart-select')
    $(chartSelectRoot).on('change', event => {
      const value = event.target.value

      const newSignupsData = statData[value].map(entry => ({
        date: parseDate(entry.date),
        value: entry.signups,
      }))

      const newRevenueData = statData[value].map(entry => ({
        date: parseDate(entry.date),
        value: Math.round(entry.revenue / 100),
      }))

      signupsChart.update(newSignupsData)
      revenueChart.update(newRevenueData)
    })
  }
}

// ---
// Init
// ---
document.addEventListener('DOMContentLoaded', function () {
  return new DashboardView($('.dashboard-view'))
})
